/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSplitPanelFragment} from '@amblique/contentful/app/contentful/fragments/split-panel/base-split-panel.fragment';
import {AccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/accordion.fragment';
import {AccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/accordion-panel.fragment';
import {CardFragment} from '@amblique/contentful/app/contentful/fragments/card/card.fragment';
import {CarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/carousel.fragment';
import {EmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/embed-panel.fragment';
import {HeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/hero-banner.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {SectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/section-panel.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullSplitPanelFragment = gql`
  ${AccordionFragment}
  ${AccordionPanelFragment}
  ${BaseSplitPanelFragment}
  ${CardFragment}
  ${CarouselFragment}
  ${EmbedPanelFragment}
  ${HeroBannerFragment}
  ${ImageFragment}
  ${RichTextBlockFragment}
  ${SectionPanelFragment}
  ${VideoFragment}

  fragment FullSplitPanelFragment on SplitPanel {
    ...BaseSplitPanelFragment

    leftContent {
      ... on Accordion {
        ...AccordionFragment
      }
      ... on AccordionPanel {
        ...AccordionPanelFragment
      }
      ... on Card {
        ...CardFragment
      }
      ... on Carousel {
        ...CarouselFragment
      }
      ... on HeroBanner {
        ...HeroBannerFragment
      }
      ... on Image {
        ...ImageFragment
      }
      ... on RichTextBlock {
        ...RichTextBlockFragment
      }
      ... on Video {
        ...VideoFragment
      }
    }
    rightContent {
      ... on Accordion {
        ...AccordionFragment
      }
      ... on AccordionPanel {
        ...AccordionPanelFragment
      }
      ... on Card {
        ...CardFragment
      }
      ... on EmbedPanel {
        ...EmbedPanelFragment
      }
      ... on HeroBanner {
        ...HeroBannerFragment
      }
      ... on Image {
        ...ImageFragment
      }
      ... on SectionPanel {
        ...SectionPanelFragment
      }
      ... on Video {
        ...VideoFragment
      }
    }
  }
`;
